import { CONSENT_KEY } from "../components/CookieBanner"

/**
 * Verifica se l'utente ha dato il consenso ai cookie analitici.
 */
function hasConsent() {
  if (typeof window === "undefined") return false
  return localStorage.getItem(CONSENT_KEY) === "accepted"
}
/**
 * Invia un evento a Google Analytics solo se l'utente ha dato consenso
 * e se gtag è disponibile.
 *
 * @param {string} eventName - Nome dell'evento GA4
 * @param {object} params    - Parametri aggiuntivi dell'evento
 */
function trackEvent(eventName, params = {}) {
  if (!hasConsent()) {
    //console.log("⚠️ Evento non tracciato (nessun consenso):", eventName)
    return
  }
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    //console.warn("⚠️ gtag non disponibile")
    return
  }
  
  window.gtag("event", eventName, params)
  //console.log("✅ Evento tracciato:", eventName, params)
}

// ─── Helper per eventi conversione ────────────────────────────────────────

/** Click sul numero di telefono */
export function trackPhoneClick() {
  trackEvent("click_telefono", {
    event_category: "contatti",
    event_label: "+39 388 659 1205",
    value: 1, // Aggiungi value per GA4
  })
}

/** Click sul link WhatsApp */
export function trackWhatsAppClick() {
  trackEvent("click_whatsapp", {
    event_category: "contatti",
    event_label: "WhatsApp",
    value: 1,
  })
}

/** Click sull'email */
export function trackEmailClick() {
  trackEvent("click_email", {
    event_category: "contatti",
    event_label: "nutrizionistalisa@outlook.it",
    value: 1,
  })
}

/** Click su Instagram */
export function trackInstagramClick() {
  trackEvent("click_instagram", {
    event_category: "social",
    event_label: "Instagram",
    value: 1,
  })
}

/**
 * Traccia lo scroll su articoli blog (>75%).
 * Da chiamare con useEffect nel template blog-post.
 * 
 * @param {string} articleTitle - Titolo dell'articolo
 * @returns {function} Cleanup function per useEffect
 */
export function trackBlogScroll(articleTitle) {
  // Verifica che siamo nel browser
  if (typeof window === "undefined") {
    return () => {} // Noop cleanup per SSR
  }

  let fired = false

  const handleScroll = () => {
    if (fired) return
    
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = window.innerHeight
    const scrollTop = window.scrollY || window.pageYOffset
    
    // Calcola percentuale scroll
    const scrolled = scrollTop / (scrollHeight - clientHeight)
    
    if (scrolled > 0.75) {
      fired = true
      trackEvent("scroll_articolo_75", {
        event_category: "blog",
        event_label: articleTitle,
        value: 75,
      })
      window.removeEventListener("scroll", handleScroll)
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: true })

  // Restituisce una funzione cleanup per useEffect
  return () => window.removeEventListener("scroll", handleScroll)
}

/** Hook generico — esporta trackEvent per usi custom */
export { trackEvent, hasConsent }